export const getRecruitNoticeList = {
  url: '/admin/recruit/notice/list.json',
  method: 'get'
};

export const getRecruitNoticeDetail = {
  url: '/admin/recruit/notice/detail.json',
  method: 'get'
};

export const saveRecruitNotice = {
  url: '/admin/recruit/notice/save.json',
  method: 'post'
};

export const recruitNoticeUpdateStatus = {
  url: '/admin/recruit/notice/updateStatus.json',
  method: 'post'
};

export const recruitNoticeUpdateTop = {
  url: '/admin/recruit/notice/updateTop.json',
  method: 'post'
};

export const getRecruitAreaTree = {
  url: '/admin/recruit/notice/getRecruitAreaTree.json',
  method: 'get'
};

export const getRecruitApplyList = {
  url: '/admin/recruit/apply/list.json',
  method: 'get'
};

export const getRecruitPersonnelList = {
  url: '/admin/recruit/personnel/list.json',
  method: 'get'
};

export const getRecruitPersonnelDetail = {
  url: '/admin/recruit/personnel/detail.json',
  method: 'get'
};

export const getRecruitBannerList = {
  url: '/admin/recruit/banner/list.json',
  method: 'get'
};

export const saveRecruitBanner = {
  url: '/admin/recruit/banner/save.json',
  method: 'post'
};

export const recruitBannerUpdateStatus = {
  url: '/admin/recruit/banner/updateStatus.json',
  method: 'post'
};

export const deleteRecruitBanner = {
  url: '/admin/recruit/banner/delete.json',
  method: 'post'
};
